// TAS Flow sayfası — tüm metin içeriği (TR / EN). Faz 1.
// Diziler ve nesne sıralamaları iki dilde birebir aynıdır; bileşenler ikonları kendi tutar.

export const TASFLOW_I18N = {
  tr: {
    seo: {
      title: "TAS Flow | Travel Automation System | Seyahat Acentesi Otomasyon Yazılımı",
      description:
        "TAS Flow; seyahat acenteleri için yapay zekâ destekli talep yönetimi, otomatik teklif, rezervasyon, müşteri portalı, SLA, raporlama ve şirket operasyonlarını tek platformda birleştiren Travel Automation System'dır.",
      schemaDesc:
        "Seyahat acenteleri için yapay zekâ destekli talep, teklif, rezervasyon, SLA, müşteri portalı ve operasyon yönetimini tek platformda birleştiren Travel Automation System.",
      featureUnit: "özellik",
    },
    hero: {
      flow: ["E-posta", "AI", "API", "Teklif", "Müşteri", "Rezervasyon"],
      titleTop: "Seyahat Operasyonlarınızı",
      titleAccent: "Uçtan Uca Yönetin",
      sub: "Talebi anlayan, seçenekleri sorgulayan, teklif oluşturan, müşteriye yanıt veren ve rezervasyona kadar süreci otomatikleştirebilen yeni nesil seyahat operasyon sistemi.",
      ctaDemo: "Canlı Demo İste",
      ctaFeatures: "223 Özelliği Keşfet",
      logoAlt: "TAS Flow — Travel Automation System",
    },
    grow: {
      line1: "Şirketiniz büyüsün.",
      line2: "İş yükünüz değil.",
      sub: "Siz TAS Flow'a uyum sağlamazsınız.",
      subAccent: "TAS Flow şirketinizin çalışma şekline uyum sağlar.",
    },
    problem: {
      title: "Bir seyahat talebi geldiğinde",
      titleAccent: "kaç kişi dokunuyor?",
      steps: [
        "Talep gelir", "Personel maili okur", "Uçuş arar", "Otel arar", "Fiyatları karşılaştırır",
        "Teklif hazırlar", "Mail yazar", "Yanıtı bekler", "Seçimi tekrar girer", "Rezervasyon oluşturur", "Bilgilendirme gönderir",
      ],
      close: "Bu sürecin tamamı",
      closeAccent: "manuel olmak zorunda değil.",
    },
    quote: {
      eyebrow: "Tam Otomatik Yanıt Sistemi",
      title: "Talepten Teklife — Otomatik",
      desc: "Bir e-posta geldiği andan müşteriye teklif gidene kadar süreç TAS Flow içinde ilerler.",
      steps: [
        { n: "01", t: "Müşteriden mail gelir", d: "\u201C22 Ekim İstanbul → Bakü, 2 kişi, ekonomi, sabah uçuşu\u201D" },
        { n: "02", t: "TAS Flow AI maili okur", d: "Müşteri, rota, tarih, yolcu sayısı, kabin, tercih ve önceliği algılar." },
        { n: "03", t: "Travel API / tedarikçileri sorgular", d: "Bağlı seyahat sistemlerinden uygun seçenekleri gerçek zamanlı çeker." },
        { n: "04", t: "Seçenekleri değerlendirir", d: "Fiyat, uygunluk, politika ve tercihlere göre en uygun alternatifleri belirler." },
        { n: "05", t: "Kurumsal teklif oluşturur", d: "Profesyonel, markalı bir teklif otomatik hazırlanır." },
        { n: "06", t: "Müşteriye otomatik yanıt gider", d: "Teklif dakikalar içinde müşteriye iletilir." },
      ],
    },
    autoRes: {
      eyebrow: "Tam Otomatik Rezervasyon Sistemi",
      titleTop: "Müşteriniz seçsin.",
      titleAccent: "TAS Flow rezerve etsin.",
      desc: "Müşteri “ikinci seçeneği alalım” dediğinde TAS Flow mesajı anlar, seçilen teklifi belirler, doğrular, rezervasyonu oluşturur, PNR/durumu sisteme işler ve müşteriye bilgi gönderir.",
      modes: [
        { t: "İnsan Onaylı Otomasyon", d: "Kritik işlemlerde sistem hazırlar, yetkili kişi onaylar. Kontrol her zaman sizde." },
        { t: "Tam Otomasyon", d: "Tanımlanan kurallar kapsamında işlem baştan sona otomatik tamamlanır." },
      ],
    },
    perCustomer: {
      title: "Her müşteriniz aynı şekilde çalışmaz.",
      titleAccent: "TAS Flow bunu bilir.",
      desc: "Tek yazılım. Farklı müşteriler için farklı iş akışları.",
      customers: [
        { c: "X Firması", w: "DOCX talep formu gönderir", d: "TAS Flow formu tanır, içeriğini okur, verileri ayrıştırır ve doğru departmana yönlendirir." },
        { c: "Y Firması", w: "Normal e-posta gönderir", d: "TAS Flow e-postayı firmanın kendi müşteri kurallarıyla değerlendirir." },
        { c: "Z Firması", w: "Müşteri portalını kullanır", d: "Talep doğrudan portal üzerinden operasyon sürecine girer." },
      ],
      tags: ["Firma bazlı kurallar", "Custom fields", "Müşteri bazlı workflow", "Özel talep formları", "Farklı SLA kuralları", "Farklı onay süreçleri", "Departman bazlı yönlendirme"],
    },
    ai: {
      eyebrow: "Yapay Zekâ & Otomasyon",
      title: "Mail okumaktan rezervasyona kadar AI operasyonun içinde.",
      caps: [
        "AI ile e-posta okuma", "Talep türü sınıflandırma", "Doğru departmana otomatik yönlendirme",
        "Aciliyet ve öncelik tespiti", "E-postadan yapılandırılmış veri çıkarımı", "Otomatik ticket oluşturma",
        "E-posta thread eşleştirme", "AI yanıt taslağı", "Dil algılama", "Rutin taleplerde otomatik aksiyon",
        "Uzun talep zincirlerini AI ile özetleme", "Politika dışı / anormal işlem uyarıları",
      ],
    },
    services: {
      eyebrow: "Travel Supplier & API Integrations",
      title: "Tüm seyahat servisleri tek platformda",
      desc: "Gerçek zamanlı sorgu, çoklu tedarikçi karşılaştırması ve birleşik teklif — modüler API altyapısıyla.",
      items: [
        { t: "Uçuş Yönetimi", d: "Yurt içi/dışı uçuş, kurumsal tarifeler, değişiklik, yolcu tercihleri ve harcama raporları." },
        { t: "Otel & Konaklama", d: "Kısa/uzun dönem ve grup konaklama, politika uyumlu seçim ve harcama analizi." },
        { t: "Araç & Transfer", d: "Araç kiralama, şoförlü araç, havalimanı ve VIP transfer, etkinlik/grup taşıma." },
        { t: "Vize Yönetimi", d: "Vize talebi, evrak checklist, randevu, süreç takibi ve grup vize süreçleri." },
        { t: "MICE / Etkinlik", d: "Etkinlik proje yönetimi, katılımcı seyahatleri, kayıt, konaklama, ulaşım ve bütçe." },
        { t: "Tur & Seyahat Hizmetleri", d: "TAS Flow ile otobüs, hızlı tren ve gemi turları gibi farklı seyahat hizmetlerini tek bir sistem üzerinden kolayca yönetin. Talepleri hızlıca değerlendirin, uygun seçenekleri sunun ve rezervasyon süreçlerini daha pratik ve verimli hale getirin." },
      ],
    },
    airlines: {
      eyebrow: "Anlaşmalı / Entegre Havayolları",
      title: "Uçak biletinde",
      titleAccent: "güçlü havayolu ağı",
      desc: "TAS Flow üzerinden aşağıdaki havayolu firmalarıyla uçak bileti süreçlerinizi yönetebilirsiniz.",
      note: "Entegrasyon ve hizmet kapsamımız sürekli genişlemektedir.",
      names: ["Türk Hava Yolları", "Pegasus Airlines", "AJet", "SunExpress", "Lufthansa"],
    },
    diff: {
      title: "Ana farkımız",
      negLabel: "Sabit kutu yazılımlar",
      negText: "Şirket → Yazılıma uyum sağlar.",
      posText: "Yazılım → Şirkete uyum sağlar.",
      posList: ["Müşterilerinizi öğrenir", "Kurallarınızı uygular", "Departmanlarınıza göre çalışır", "Workflow'unuza adapte olur", "İhtiyacınız olan modüllerle genişler"],
    },
    closing: {
      title: "Acentanıza özel TAS Flow'u görün",
      desc: "223 özelliklik büyük bir platform. Size operasyonunuza uyarlanmış hâlini gösterelim.",
      ctaDemo: "Canlı Demo İste",
      ctaContact: "Bizimle İletişime Geç",
      note: "223 özellik · Starter / Plus / Pro paketleri · yapay zekâ destekli seyahat otomasyonu.",
    },
    story: {
      pulse: {
        eyebrow: "TAS Flow Pulse",
        title: "Operasyonunuzun kalbi,",
        accent: "tek ekranda canlı.",
        desc: "TAS Flow Pulse; tüm talepleri, teklifleri, rezervasyonları ve SLA durumunu gerçek zamanlı izler. Ekibiniz neyin nerede olduğunu saniyeler içinde görür.",
        points: [
          "Canlı talep, teklif ve rezervasyon akışı",
          "Anlık SLA & yanıt süresi göstergeleri",
          "Departman ve çalışan bazlı canlı yük dağılımı",
          "Kritik durumlar için gerçek zamanlı uyarılar",
        ],
      },
      intelligence: {
        eyebrow: "TAS Flow Intelligence",
        title: "Verilerinizi karara,",
        accent: "kararı büyümeye dönüştürün.",
        desc: "TAS Flow Intelligence; talep, gelir, tedarikçi ve müşteri verilerini işleyip trendleri ve fırsatları önceden görmenizi sağlar.",
        points: [
          "Talep, gelir ve kârlılık trend analizleri",
          "Müşteri ve tedarikçi performans skorları",
          "AI destekli öngörü ve senaryo tahminleri",
          "Maliyet optimizasyonu ve tasarruf önerileri",
        ],
      },
      portal: {
        eyebrow: "Müşteri Portalı",
        title: "Müşterileriniz talebi açsın,",
        accent: "süreci kendisi izlesin.",
        desc: "Kurumsal müşterileriniz kendi self-servis portalından talep açar, teklifleri görür, onaylar ve rezervasyon geçmişine erişir. Telefon trafiği azalır, memnuniyet artar.",
        points: [
          "7/24 talep açma ve durum takibi",
          "Teklif görüntüleme, onay ve mesajlaşma",
          "Rezervasyon geçmişi ve rapor indirme",
          "Firmaya özel marka, kural ve form yapısı",
        ],
      },
      finance: {
        eyebrow: "Finans & Faturalama",
        title: "Operasyondan faturaya,",
        accent: "tek akışta.",
        desc: "Her talep, teklif ve rezervasyon finansal tarafla otomatik bağlanır. Fatura, cari, tahsilat ve kârlılık tek platformdan izlenir, muhasebe/ERP'ye aktarılır.",
        points: [
          "Otomatik fatura ve cari hesap takibi",
          "Tahsilat, vade ve alacak yönetimi",
          "Müşteri ve işlem bazlı kârlılık analizi",
          "Muhasebe / ERP entegrasyonu (Pro)",
        ],
      },
      hr: {
        eyebrow: "İnsan Kaynakları",
        title: "Ekibinizi de aynı platformdan",
        accent: "yönetin.",
        desc: "Giriş/çıkış (PDKS), izin, mesai ve özlük süreçleri operasyonla aynı sistemde. Kim nerede, kim müsait, kim izinde — hepsi tek bakışta.",
        points: [
          "PDKS: giriş/çıkış ve mesai takibi",
          "İzin, vardiya ve uzaktan çalışma yönetimi",
          "Personel özlük ve self-servis işlemleri",
          "Ekip kapasitesi ve yük dağılımı görünürlüğü",
        ],
      },
    },
    storyVisuals: {
      pulse: {
        live: "Canlı Operasyon",
        now: "Şimdi",
        stats: [
          { l: "Aktif Talep", v: "47", d: "+12%" },
          { l: "Bekleyen Onay", v: "8", d: "-3" },
          { l: "Ort. Yanıt", v: "3.2dk", d: "-41%" },
          { l: "SLA Uyumu", v: "%98", d: "+2%" },
        ],
        feed: ["Yeni talep — İstanbul → Bakü", "Teklif gönderildi — X Firması", "Rezervasyon onaylandı — PNR", "SLA uyarısı — 2 talep"],
      },
      intelligence: {
        title: "Talep & Gelir Trendi",
        days: ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"],
        aiTitle: "AI Öngörüsü",
        aiText: "Önümüzdeki hafta uçuş talebi %18 artabilir. Kapasiteyi Cuma öncesi planlayın.",
      },
      portal: {
        url: "portal.acenteniz.com",
        heading: "Taleplerim",
        newRequest: "+ Yeni Talep",
        rows: [
          { t: "İstanbul → Londra · 2 kişi", s: "Teklif Hazır" },
          { t: "Otel · Ankara · 3 gece", s: "Onaylandı" },
          { t: "Vize · Schengen", s: "İşlemde" },
        ],
      },
      finance: {
        revenueLabel: "Aylık Ciro",
        revenueValue: "₺1.24M",
        revenueNote: "+18% önceki aya göre",
        collectionLabel: "Tahsilat Oranı",
        collectionValue: "%92",
        rows: [
          { n: "FT-2041 · X Firması", a: "₺84.200", s: "Ödendi" },
          { n: "FT-2042 · Y Firması", a: "₺52.900", s: "Bekliyor" },
          { n: "FT-2043 · Z Firması", a: "₺119.400", s: "Vadeli" },
        ],
      },
      hr: {
        title: "Ekip · Giriş/Çıkış (PDKS)",
        today: "Bugün",
        stats: [{ l: "Mevcut", v: "18" }, { l: "İzinli", v: "3" }, { l: "Uzaktan", v: "5" }],
        team: [
          { n: "Ayşe K.", r: "Operasyon", in: "08:54", st: "Aktif" },
          { n: "Mehmet D.", r: "Rezervasyon", in: "09:02", st: "Aktif" },
          { n: "Zeynep A.", r: "Muhasebe", in: "İzinli", st: "İzin" },
          { n: "Can B.", r: "Satış", in: "09:15", st: "Uzaktan" },
        ],
      },
    },
    features: {
      badge: "Paket Karşılaştırma",
      title: "223 Özellik.",
      titleAccent: "Tek Platform.",
      desc: "Seyahat operasyonlarından müşteri yönetimine, yapay zekâdan raporlamaya, finanstan insan kaynaklarına kadar. Her özelliğin hangi pakette olduğunu aşağıdan inceleyin.",
      scrollHint: "Paketleri görmek için tabloyu yana kaydırın",
      colFeature: "Özellik",
      popular: "Popüler",
      footnote: (n) => `Üst paketler alt paketlerdeki tüm özellikleri içerir. Toplam ${n} özellik.`,
      cta: "Acentanıza Özel Teklif Alın",
    },
    packagesSection: {
      badge: "Paketler",
      title: "İhtiyacınız kadar başlayın.",
      desc: "Üst paketler alt paketlerdeki tüm özellikleri içerir.",
      featureWord: "özellik",
      pricingTitle: "TAS Flow fiyatı nasıl belirlenir?",
    },
    packages: [
      {
        id: "starter",
        name: "Starter",
        tagline: "Operasyonunu dijitalleştirmeye başlayan acenteler.",
        featureCount: 27,
        priceLabel: "Teklife Özel",
        priceNote: "Kurulum + lisans",
        highlight: false,
        cta: "Starter Teklifi Al",
        highlights: [
          "Tek merkez operasyon paneli",
          "Çok kullanıcılı yapı & rol yetkilendirme",
          "İç talep & ticket sistemi",
          "Departman atama & talep mesajlaşması",
          "Yurt içi uçuş & kısa dönem konaklama",
          "Görev yönetimi & kişisel yapılacaklar",
          "Excel/PDF export, mobil uyum",
        ],
      },
      {
        id: "plus",
        name: "Plus",
        tagline: "Yapay zekâ ve otomasyonla operasyonunu hızlandıran acenteler.",
        featureCount: 144,
        priceLabel: "Teklife Özel",
        priceNote: "Kurulum + lisans + servis",
        highlight: true,
        badge: "EN ÇOK TERCİH EDİLEN",
        cta: "Plus Teklifi Al",
        highlights: [
          "Starter'ın tamamı +",
          "AI ile e-posta okuma & talep sınıflandırma",
          "Canlı uçuş/otel/araç sorgu & çoklu tedarikçi",
          "Yurt dışı uçuş, transfer, vize",
          "SLA takibi & eskalasyon",
          "Seyahat politikası, bütçe & onay akışı",
          "Canlı dashboard, analitik, müşteri portalı",
          "CRM, finans takibi, İK/PDKS, otomasyon kuralları",
        ],
      },
      {
        id: "pro",
        name: "Pro",
        tagline: "Uçtan uca tam otomasyon isteyen kurumsal acenteler.",
        featureCount: 223,
        priceLabel: "Teklife Özel",
        priceNote: "Kurulum + lisans + servis + özel geliştirme",
        highlight: false,
        badge: "FULL AUTOMATION",
        cta: "Pro Demo İste",
        highlights: [
          "Plus'ın tamamı +",
          "Tam otomatik yanıt & tam otomatik rezervasyon",
          "Rezervasyon/opsiyon, PNR takibi, iptal/değişiklik",
          "AI yanıt taslakları, özet & anomali uyarıları",
          "Multi-tenant, MICE, VIP/grup transfer",
          "No-code kural motoru & workflow designer",
          "Duty of Care, maliyet optimizasyonu, ERP mutabakat",
          "2FA, external API, premium destek & account manager",
        ],
      },
    ],
    pricingModel: [
      { title: "Kurulum & Onboarding", desc: "Kurulum, yapılandırma ve ekip eğitimi." },
      { title: "Paket / Lisans Bedeli", desc: "Seçtiğiniz TAS Flow paketinin lisansı." },
      { title: "Altyapı & Servis", desc: "Kullanım hacmi ve altyapı/servis bedeli." },
      { title: "Özel Geliştirme & Entegrasyon", desc: "Size özel modül ve sistem entegrasyonları." },
    ],
    pricingNote:
      "Her seyahat acentasının kullanıcı sayısı, işlem hacmi, entegrasyonları ve operasyon yapısı farklıdır. Bu nedenle TAS Flow ihtiyaçlarınıza göre yapılandırılır ve tekliflendirilir.",
    roi: {
      badge: "Operasyon Tasarrufu Hesaplayıcı",
      title: "Ne kadar zaman kazanabilirsiniz?",
      fields: {
        requests: "Aylık talep sayısı",
        minutes: "Talep başına ort. dakika",
        staff: "Operasyon çalışan sayısı",
        cost: "Kişi başı aylık maliyet (₺)",
        rate: "Tahmini otomasyon oranı (%)",
      },
      stats: {
        manual: "Manuel işlem (saat/ay)",
        after: "Otomasyon sonrası (saat/ay)",
        saved: "Kazanılan zaman (saat/ay)",
        gain: "Tahmini kazanç (₺/ay)",
      },
      hourUnit: "saat",
      locale: "tr-TR",
      note: "Sonuçlar girdiğiniz değerlere dayalı tahminidir; garanti edilen bir tasarruf rakamı değildir.",
    },
    faq: {
      badge: "Sık Sorulan Sorular",
      title: "TAS Flow hakkında merak edilenler",
      items: [
        { q: "TAS Flow nedir?", a: "TAS Flow (Travel Automation System); seyahat acentelerinin talep, teklif, rezervasyon, ekip operasyonu, SLA, müşteri iletişimi ve raporlama süreçlerini yapay zekâ ve otomasyonla tek platformdan yöneten bir seyahat operasyon sistemidir." },
        { q: "TAS Flow kimler için uygundur?", a: "Kurumsal seyahat operasyonu yürüten seyahat acenteleri, tur operatörleri ve şirketlerin seyahat departmanları için uygundur." },
        { q: "TAS Flow seyahat acentelerinde neyi otomatikleştirir?", a: "E-posta ile gelen talebin okunmasından, seyahat API sorgusuna, teklif oluşturmaya, müşteriye yanıta ve rezervasyona kadar operasyonun büyük bölümünü otomatikleştirebilir." },
        { q: "TAS Flow e-postaları nasıl işler?", a: "Yapay zekâ gelen e-postayı okur; müşteriyi, rotayı, tarihi, yolcu sayısını ve tercihleri algılar, talebi sınıflandırır ve doğru departmana yönlendirir." },
        { q: "Müşteriye otomatik teklif gönderebilir mi?", a: "Evet. Tam Otomatik Yanıt Sistemi; seçenekleri sorgular, değerlendirir, kurumsal teklif oluşturur ve müşteriye otomatik gönderebilir." },
        { q: "TAS Flow otomatik rezervasyon yapabilir mi?", a: "Evet. Müşterinin seçim mesajını anlar, seçilen teklifi belirler ve bağlı rezervasyon altyapısında işlemi oluşturur. İnsan onaylı veya tam otomatik modda çalışabilir." },
        { q: "Mevcut seyahat API'lerimizle çalışabilir mi?", a: "Evet. TAS Flow modüler API yapısıyla farklı seyahat sağlayıcıları ve tedarikçi sistemleriyle entegre olabilir." },
        { q: "Her müşteri için farklı süreç oluşturabilir miyiz?", a: "Evet. Firma bazlı kurallar, özel talep formları, custom field'lar, farklı SLA ve onay süreçleriyle her müşteriye özel iş akışı tanımlanabilir." },
        { q: "TAS Flow müşteri portalı içeriyor mu?", a: "Evet. Kurumsal müşterileriniz portal üzerinden talep açabilir, durum izleyebilir, rezervasyon geçmişini görüntüleyebilir ve rapor indirebilir." },
        { q: "TAS Flow ile SLA takip edilebilir mi?", a: "Evet. Talep cevaplama süresi, SLA hedefleri, ihlaller ve departman/çalışan performansı ölçülebilir." },
        { q: "Muhasebe/ERP sistemiyle entegre olabilir mi?", a: "Evet. Fatura, cari ve ödeme bilgileri muhasebe/ERP sistemlerinize API üzerinden aktarılabilir (Pro)." },
        { q: "İnsan kaynakları modülü var mı?", a: "Evet. İhtiyaca göre PDKS, izin, mesai, özlük ve personel self-servis gibi İK modülleri eklenebilir." },
        { q: "TAS Flow bulut tabanlı mı?", a: "Evet. Bilgisayar, tablet ve mobilden erişilebilen bulut altyapısıyla çalışır; rol bazlı erişim, güvenli oturum ve audit log içerir." },
        { q: "Starter, Plus ve Pro arasındaki fark nedir?", a: "Starter (27 özellik) operasyonu dijitalleştirir; Plus (144 özellik) AI ve otomasyon ekler; Pro (223 özellik) uçtan uca tam otomasyon sunar. Üst paket alt paketleri kapsar." },
        { q: "TAS Flow fiyatı nasıl belirlenir?", a: "Fiyat; kurulum & onboarding, paket/lisans, altyapı & servis ve özel geliştirme olmak üzere dört bileşenden oluşur ve ihtiyacınıza göre tekliflendirilir." },
      ],
    },
    demo: {
      badge: "Canlı Demo",
      title: "Acentanıza özel TAS Flow'u görün",
      desc: "Formu doldurun; size operasyonunuza uyarlanmış demosunu gösterelim.",
      ph: {
        name: "Ad Soyad *",
        company: "Firma *",
        role: "Görev / Pozisyon",
        phone: "Telefon",
        email: "E-posta *",
        employees: "Çalışan sayısı",
        requests: "Aylık yaklaşık seyahat talebi",
        system: "Kullandığınız mevcut sistem",
        problem: "En büyük operasyon probleminiz",
      },
      packagePrefix: "İlgilendiğiniz paket:",
      unknown: "Bilmiyorum",
      kvkk: "KVKK kapsamında verilerimin işlenmesini kabul ediyorum.",
      error: "Bir hata oluştu, lütfen tekrar deneyin.",
      sending: "Gönderiliyor...",
      submit: "Canlı Demo İste",
      successTitle: "Talebiniz alındı!",
      successDesc: "Ekibimiz en kısa sürede size acentanıza özel TAS Flow demosu için ulaşacak.",
    },
  },

  en: {
    seo: {
      title: "TAS Flow | Travel Automation System | Travel Agency Automation Software",
      description:
        "TAS Flow is a Travel Automation System that unifies AI-powered request management, automated quoting, booking, a customer portal, SLA tracking, reporting and back-office operations for travel agencies on a single platform.",
      schemaDesc:
        "A Travel Automation System that unifies AI-powered request handling, quoting, booking, SLA tracking, customer portal and operations management for travel agencies on one platform.",
      featureUnit: "features",
    },
    hero: {
      flow: ["Email", "AI", "API", "Quote", "Customer", "Booking"],
      titleTop: "Run Your Travel Operations",
      titleAccent: "End to End",
      sub: "A new-generation travel operations system that understands the request, searches the options, builds the quote, replies to your customer and can automate the process all the way to booking.",
      ctaDemo: "Request a Live Demo",
      ctaFeatures: "Explore 223 Features",
      logoAlt: "TAS Flow — Travel Automation System",
    },
    grow: {
      line1: "Grow your company.",
      line2: "Not your workload.",
      sub: "You don't adapt to TAS Flow.",
      subAccent: "TAS Flow adapts to the way your company works.",
    },
    problem: {
      title: "When a travel request arrives,",
      titleAccent: "how many people touch it?",
      steps: [
        "Request arrives", "Staff reads the email", "Searches flights", "Searches hotels", "Compares prices",
        "Prepares the quote", "Writes the email", "Waits for a reply", "Re-enters the selection", "Creates the booking", "Sends the confirmation",
      ],
      close: "None of this process",
      closeAccent: "has to stay manual.",
    },
    quote: {
      eyebrow: "Fully Automated Response System",
      title: "From Request to Quote — Automatically",
      desc: "From the moment an email arrives until the quote reaches your customer, the entire process runs inside TAS Flow.",
      steps: [
        { n: "01", t: "The customer's email arrives", d: "\u201COct 22, Istanbul → Baku, 2 passengers, economy, morning flight\u201D" },
        { n: "02", t: "TAS Flow AI reads the email", d: "It detects the customer, route, dates, passenger count, cabin, preferences and priority." },
        { n: "03", t: "It queries travel APIs / suppliers", d: "Available options are pulled in real time from your connected travel systems." },
        { n: "04", t: "It evaluates the options", d: "The best alternatives are selected based on price, availability, policy and preferences." },
        { n: "05", t: "It builds a corporate quote", d: "A professional, branded quote is generated automatically." },
        { n: "06", t: "The customer receives an automatic reply", d: "The quote reaches your customer within minutes." },
      ],
    },
    autoRes: {
      eyebrow: "Fully Automated Booking System",
      titleTop: "Let your customer choose.",
      titleAccent: "Let TAS Flow book it.",
      desc: "When the customer replies “let's take the second option”, TAS Flow understands the message, identifies the selected quote, validates it, creates the booking, records the PNR/status and informs the customer.",
      modes: [
        { t: "Human-Approved Automation", d: "For critical actions the system prepares everything and an authorised user approves. You always stay in control." },
        { t: "Full Automation", d: "Within your defined rules, the transaction is completed end to end automatically." },
      ],
    },
    perCustomer: {
      title: "Not every customer works the same way.",
      titleAccent: "TAS Flow knows that.",
      desc: "One platform. Different workflows for different customers.",
      customers: [
        { c: "Company X", w: "Sends a DOCX request form", d: "TAS Flow recognises the form, reads its content, parses the data and routes it to the right department." },
        { c: "Company Y", w: "Sends a plain email", d: "TAS Flow evaluates the email using that company's own customer rules." },
        { c: "Company Z", w: "Uses the customer portal", d: "The request enters the operations flow directly through the portal." },
      ],
      tags: ["Company-based rules", "Custom fields", "Customer-based workflows", "Custom request forms", "Different SLA rules", "Different approval flows", "Department-based routing"],
    },
    ai: {
      eyebrow: "Artificial Intelligence & Automation",
      title: "From reading the email to creating the booking, AI works inside your operation.",
      caps: [
        "AI-powered email reading", "Request type classification", "Automatic routing to the right department",
        "Urgency and priority detection", "Structured data extraction from email", "Automatic ticket creation",
        "Email thread matching", "AI-drafted replies", "Language detection", "Automatic action on routine requests",
        "AI summaries of long request threads", "Out-of-policy / anomaly alerts",
      ],
    },
    services: {
      eyebrow: "Travel Supplier & API Integrations",
      title: "Every travel service on one platform",
      desc: "Real-time search, multi-supplier comparison and a unified quote — powered by a modular API infrastructure.",
      items: [
        { t: "Flight Management", d: "Domestic and international flights, corporate fares, changes, traveller preferences and spend reports." },
        { t: "Hotel & Accommodation", d: "Short-term, long-term and group accommodation, policy-compliant selection and spend analysis." },
        { t: "Car & Transfer", d: "Car rental, chauffeur-driven cars, airport and VIP transfers, event and group transport." },
        { t: "Visa Management", d: "Visa requests, document checklists, appointments, process tracking and group visa handling." },
        { t: "MICE / Events", d: "Event project management, attendee travel, registration, accommodation, transport and budgets." },
        { t: "Tour & Travel Services", d: "With TAS Flow you can easily manage different travel services such as coach, high-speed rail and cruise tours from a single system. Evaluate requests quickly, present the right options and make your booking processes far more practical and efficient." },
      ],
    },
    airlines: {
      eyebrow: "Contracted / Integrated Airlines",
      title: "A strong airline network",
      titleAccent: "for air ticketing",
      desc: "Through TAS Flow you can manage your air ticketing processes with the airlines listed below.",
      note: "Our integration and service coverage keeps expanding.",
      names: ["Turkish Airlines", "Pegasus Airlines", "AJet", "SunExpress", "Lufthansa"],
    },
    diff: {
      title: "Our core difference",
      negLabel: "Rigid off-the-shelf software",
      negText: "Company → adapts to the software.",
      posText: "Software → adapts to the company.",
      posList: ["Learns your customers", "Applies your rules", "Works the way your departments work", "Adapts to your workflow", "Scales with the modules you need"],
    },
    closing: {
      title: "See TAS Flow built around your agency",
      desc: "It's a large platform with 223 features. Let us show you the version tailored to your operation.",
      ctaDemo: "Request a Live Demo",
      ctaContact: "Get in Touch",
      note: "223 features · Starter / Plus / Pro packages · AI-powered travel automation.",
    },
    story: {
      pulse: {
        eyebrow: "TAS Flow Pulse",
        title: "The heart of your operation,",
        accent: "live on one screen.",
        desc: "TAS Flow Pulse monitors every request, quote, booking and SLA status in real time. Your team sees what is where within seconds.",
        points: [
          "Live request, quote and booking stream",
          "Instant SLA & response time indicators",
          "Live workload distribution per department and employee",
          "Real-time alerts for critical situations",
        ],
      },
      intelligence: {
        eyebrow: "TAS Flow Intelligence",
        title: "Turn your data into decisions,",
        accent: "and decisions into growth.",
        desc: "TAS Flow Intelligence processes your request, revenue, supplier and customer data so you can see trends and opportunities before they happen.",
        points: [
          "Request, revenue and profitability trend analysis",
          "Customer and supplier performance scores",
          "AI-powered forecasts and scenario modelling",
          "Cost optimisation and savings recommendations",
        ],
      },
      portal: {
        eyebrow: "Customer Portal",
        title: "Let your customers raise requests,",
        accent: "and follow the process themselves.",
        desc: "Your corporate customers raise requests in their own self-service portal, view and approve quotes and access their booking history. Phone traffic drops, satisfaction rises.",
        points: [
          "24/7 request creation and status tracking",
          "Quote viewing, approval and messaging",
          "Booking history and report downloads",
          "Company-specific branding, rules and form structure",
        ],
      },
      finance: {
        eyebrow: "Finance & Invoicing",
        title: "From operation to invoice,",
        accent: "in a single flow.",
        desc: "Every request, quote and booking is automatically linked to the financial side. Invoices, balances, collections and profitability are tracked on one platform and pushed to accounting/ERP.",
        points: [
          "Automatic invoicing and account balance tracking",
          "Collections, due dates and receivables management",
          "Profitability analysis per customer and transaction",
          "Accounting / ERP integration (Pro)",
        ],
      },
      hr: {
        eyebrow: "Human Resources",
        title: "Manage your team from the",
        accent: "same platform.",
        desc: "Time & attendance, leave, overtime and employee records live in the same system as your operation. Who is where, who is available, who is on leave — all at a glance.",
        points: [
          "Time & attendance: clock-in/out and overtime tracking",
          "Leave, shift and remote work management",
          "Employee records and self-service actions",
          "Visibility into team capacity and workload",
        ],
      },
    },
    storyVisuals: {
      pulse: {
        live: "Live Operations",
        now: "Now",
        stats: [
          { l: "Active Requests", v: "47", d: "+12%" },
          { l: "Pending Approvals", v: "8", d: "-3" },
          { l: "Avg. Response", v: "3.2 min", d: "-41%" },
          { l: "SLA Compliance", v: "98%", d: "+2%" },
        ],
        feed: ["New request — Istanbul → Baku", "Quote sent — Company X", "Booking confirmed — PNR", "SLA alert — 2 requests"],
      },
      intelligence: {
        title: "Request & Revenue Trend",
        days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        aiTitle: "AI Forecast",
        aiText: "Flight demand may rise by 18% next week. Plan your capacity before Friday.",
      },
      portal: {
        url: "portal.youragency.com",
        heading: "My Requests",
        newRequest: "+ New Request",
        rows: [
          { t: "Istanbul → London · 2 pax", s: "Quote Ready" },
          { t: "Hotel · Ankara · 3 nights", s: "Approved" },
          { t: "Visa · Schengen", s: "In Progress" },
        ],
      },
      finance: {
        revenueLabel: "Monthly Revenue",
        revenueValue: "₺1.24M",
        revenueNote: "+18% vs. previous month",
        collectionLabel: "Collection Rate",
        collectionValue: "92%",
        rows: [
          { n: "INV-2041 · Company X", a: "₺84,200", s: "Paid" },
          { n: "INV-2042 · Company Y", a: "₺52,900", s: "Pending" },
          { n: "INV-2043 · Company Z", a: "₺119,400", s: "On Terms" },
        ],
      },
      hr: {
        title: "Team · Time & Attendance",
        today: "Today",
        stats: [{ l: "Present", v: "18" }, { l: "On Leave", v: "3" }, { l: "Remote", v: "5" }],
        team: [
          { n: "Ayşe K.", r: "Operations", in: "08:54", st: "Active" },
          { n: "Mehmet D.", r: "Reservations", in: "09:02", st: "Active" },
          { n: "Zeynep A.", r: "Accounting", in: "On leave", st: "Leave" },
          { n: "Can B.", r: "Sales", in: "09:15", st: "Remote" },
        ],
      },
    },
    features: {
      badge: "Package Comparison",
      title: "223 Features.",
      titleAccent: "One Platform.",
      desc: "From travel operations to customer management, from artificial intelligence to reporting, from finance to human resources. See exactly which package includes each feature below.",
      scrollHint: "Scroll the table sideways to see the packages",
      colFeature: "Feature",
      popular: "Popular",
      footnote: (n) => `Higher packages include everything in the lower ones. ${n} features in total.`,
      cta: "Get a Quote for Your Agency",
    },
    packagesSection: {
      badge: "Packages",
      title: "Start with exactly what you need.",
      desc: "Higher packages include everything in the lower ones.",
      featureWord: "features",
      pricingTitle: "How is TAS Flow priced?",
    },
    packages: [
      {
        id: "starter",
        name: "Starter",
        tagline: "For agencies starting to digitalise their operation.",
        featureCount: 27,
        priceLabel: "Custom Quote",
        priceNote: "Setup + licence",
        highlight: false,
        cta: "Get a Starter Quote",
        highlights: [
          "Single centralised operations console",
          "Multi-user structure & role permissions",
          "Internal request & ticket system",
          "Department assignment & in-request messaging",
          "Domestic flights & short-term accommodation",
          "Task management & personal to-do lists",
          "Excel/PDF export, mobile ready",
        ],
      },
      {
        id: "plus",
        name: "Plus",
        tagline: "For agencies accelerating their operation with AI and automation.",
        featureCount: 144,
        priceLabel: "Custom Quote",
        priceNote: "Setup + licence + service",
        highlight: true,
        badge: "MOST POPULAR",
        cta: "Get a Plus Quote",
        highlights: [
          "Everything in Starter +",
          "AI email reading & request classification",
          "Live flight/hotel/car search & multi-supplier",
          "International flights, transfers, visas",
          "SLA tracking & escalation",
          "Travel policy, budget & approval flows",
          "Live dashboard, analytics, customer portal",
          "CRM, finance tracking, HR/time-attendance, automation rules",
        ],
      },
      {
        id: "pro",
        name: "Pro",
        tagline: "For enterprise agencies that want true end-to-end automation.",
        featureCount: 223,
        priceLabel: "Custom Quote",
        priceNote: "Setup + licence + service + custom development",
        highlight: false,
        badge: "FULL AUTOMATION",
        cta: "Request a Pro Demo",
        highlights: [
          "Everything in Plus +",
          "Fully automated replies & fully automated booking",
          "Bookings/options, PNR tracking, cancellations/changes",
          "AI reply drafts, summaries & anomaly alerts",
          "Multi-tenant, MICE, VIP/group transfers",
          "No-code rule engine & workflow designer",
          "Duty of Care, cost optimisation, ERP reconciliation",
          "2FA, external API, premium support & account manager",
        ],
      },
    ],
    pricingModel: [
      { title: "Setup & Onboarding", desc: "Installation, configuration and team training." },
      { title: "Package / Licence Fee", desc: "The licence for the TAS Flow package you choose." },
      { title: "Infrastructure & Service", desc: "Usage volume plus infrastructure and service costs." },
      { title: "Custom Development & Integration", desc: "Modules and system integrations built for you." },
    ],
    pricingNote:
      "Every travel agency has a different number of users, transaction volume, integrations and operating model. That is why TAS Flow is configured and quoted around your specific needs.",
    roi: {
      badge: "Operational Savings Calculator",
      title: "How much time could you save?",
      fields: {
        requests: "Monthly number of requests",
        minutes: "Avg. minutes per request",
        staff: "Number of operations staff",
        cost: "Monthly cost per person (₺)",
        rate: "Estimated automation rate (%)",
      },
      stats: {
        manual: "Manual work (hours/month)",
        after: "After automation (hours/month)",
        saved: "Time saved (hours/month)",
        gain: "Estimated saving (₺/month)",
      },
      hourUnit: "hours",
      locale: "en-US",
      note: "Results are estimates based on the values you enter and are not a guaranteed saving figure.",
    },
    faq: {
      badge: "Frequently Asked Questions",
      title: "Everything you want to know about TAS Flow",
      items: [
        { q: "What is TAS Flow?", a: "TAS Flow (Travel Automation System) is a travel operations system that lets travel agencies manage requests, quotes, bookings, team operations, SLAs, customer communication and reporting from a single platform with artificial intelligence and automation." },
        { q: "Who is TAS Flow for?", a: "It is built for travel agencies running corporate travel operations, tour operators and in-house corporate travel departments." },
        { q: "What does TAS Flow automate in a travel agency?", a: "It can automate a large part of the operation: from reading the incoming email to querying travel APIs, generating the quote, replying to the customer and creating the booking." },
        { q: "How does TAS Flow process emails?", a: "The AI reads the incoming email, detects the customer, route, dates, passenger count and preferences, classifies the request and routes it to the right department." },
        { q: "Can it send quotes to customers automatically?", a: "Yes. The Fully Automated Response System searches options, evaluates them, builds a corporate quote and can send it to the customer automatically." },
        { q: "Can TAS Flow create bookings automatically?", a: "Yes. It understands the customer's selection message, identifies the chosen quote and creates the transaction in the connected booking infrastructure. It can run in human-approved or fully automated mode." },
        { q: "Can it work with our existing travel APIs?", a: "Yes. With its modular API structure TAS Flow can integrate with different travel providers and supplier systems." },
        { q: "Can we define a different process for each customer?", a: "Yes. Company-based rules, custom request forms, custom fields, different SLAs and approval flows let you define a dedicated workflow for every customer." },
        { q: "Does TAS Flow include a customer portal?", a: "Yes. Your corporate customers can raise requests, track status, view booking history and download reports through the portal." },
        { q: "Can SLAs be tracked with TAS Flow?", a: "Yes. Response times, SLA targets, breaches and department/employee performance can all be measured." },
        { q: "Can it integrate with our accounting/ERP system?", a: "Yes. Invoice, account and payment data can be pushed to your accounting/ERP systems via API (Pro)." },
        { q: "Is there a human resources module?", a: "Yes. HR modules such as time & attendance, leave, overtime, employee records and staff self-service can be added as needed." },
        { q: "Is TAS Flow cloud based?", a: "Yes. It runs on cloud infrastructure accessible from desktop, tablet and mobile, with role-based access, secure sessions and audit logs." },
        { q: "What is the difference between Starter, Plus and Pro?", a: "Starter (27 features) digitalises the operation; Plus (144 features) adds AI and automation; Pro (223 features) delivers full end-to-end automation. Each higher package includes the lower ones." },
        { q: "How is TAS Flow priced?", a: "Pricing has four components — setup & onboarding, package/licence, infrastructure & service and custom development — and is quoted around your needs." },
      ],
    },
    demo: {
      badge: "Live Demo",
      title: "See TAS Flow built around your agency",
      desc: "Fill in the form and we will show you a demo tailored to your operation.",
      ph: {
        name: "Full Name *",
        company: "Company *",
        role: "Role / Position",
        phone: "Phone",
        email: "Email *",
        employees: "Number of employees",
        requests: "Approx. monthly travel requests",
        system: "Your current system",
        problem: "Your biggest operational problem",
      },
      packagePrefix: "Package you're interested in:",
      unknown: "Not sure yet",
      kvkk: "I consent to the processing of my personal data under the applicable data protection law.",
      error: "Something went wrong, please try again.",
      sending: "Sending...",
      submit: "Request a Live Demo",
      successTitle: "We've received your request!",
      successDesc: "Our team will contact you shortly to arrange a TAS Flow demo tailored to your agency.",
    },
  },
};
